export const services = {
  seo: {
    title: 'サービス | LensBank プロ機材レンタル',
    description: 'プロ機材レンタル、台日撮影協力、日本編集・カラグレ、Urent 寄託レンタルを提供。ワンストップ映像制作ソリューションで、すべての撮影ニーズに対応。',
    keywords: '機材レンタル,台日撮影,編集カラグレ,寄託レンタル,映像制作'
  },
  hero: {
    title: 'サービス',
    subtitle: 'ワンストップ映像制作ソリューション'
  },
  equipment: {
    title: 'プロ機材レンタル',
    subtitle: '1,000点以上のプロ撮影機材',
    desc: 'カメラ、レンズ、照明、録音、モニター、スタビライザーなど、全方位のプロ機材レンタルサービスを提供。すべての機材は定期的にメンテナンスされ、最適な使用状態が保たれます。',
    features: [
      '多ブランド選択：Canon、Sony、RED、ARRIなど',
      '柔軟なレンタル期間：日貸し、週貸し、月貸し',
      '専門コンサルティング：最適な機材構成をサポート',
      '技術サポート：使用方法の指導とトラブルシューティング',
      '保険サービス：完全な機材保険プラン（日本限定）'
    ]
  },
  japanRental: {
    sectionLabel: '日本機材レンタルサービス',
    title: '日本機材レンタルサービス',
    content: 'LensBankは信頼できるパートナーとして日本の東京に拠点を持つTREE Digital Studio Inc.の撮影機材レンタル部門CRANKをご紹介することができます。\n\nTREE Digital Studio Inc.には中国語対応が可能なスタッフも在籍しており、台湾からの撮影チームにとってスムーズなやりとりが可能です。\nなおTREE Digital Studio Inc.（CRANK）はLensBankを介さずに直接ご利用いただくことも可能です。\nお客様のご要望に合わせて、最適な方法を柔軟にお選びいただけます。',
    learnMore: '詳しく見る',
    priceNote: '日本機材レンタルは、日本の公式見積もりを基準とします。台湾側では各種サポートサービスを提供いたします。'
  },
  portfolio: {
    title: '機材協力',
    subtitle: '厳選作品集',
    desc: '私たちの機材は多くの優れた映像作品の撮影に参加しています。以下は一部の制作実績です。',
    viewAll: 'もっと見る'
  },
  crew: {
    subtitle: 'プロチーム',
    title: 'プロスタッフ派遣実績',
    desc: '私たちのプロ撮影チームは、広告撮影からドキュメンタリー制作まで、様々なプロジェクトに派遣サービスを提供しています',
    viewAll: 'もっと派遣作品を見る'
  },
  taiwanJapan: {
    hero: {
      title: '台日撮影制作サービス',
      description: '台湾と日本間の国境を越えた撮影協力サービスを提供。機材レンタル、撮影チーム、ロケーション調整、行政支援など、ワンストップソリューション。'
    },
    features: {
      title: 'サービスの特徴',
      equipment: {
        title: '機材の国境を越えた調達',
        description: '台日両地のプロ機材レンタルと国境越え輸送サービスを提供し、撮影機材の時間通りの配置を確保。'
      },
      team: {
        title: '現地撮影チーム',
        description: '経験豊富な現地撮影チームを配置し、現地の撮影環境と文化に精通。'
      },
      logistics: {
        title: 'ロケーションと行政調整',
        description: 'ロケハン、撮影許可申請、行政手続きなどの煩雑業務を支援。'
      },
      support: {
        title: '全程サポートサービス',
        description: '翻訳、コミュニケーション調整、ロジスティック支援など全方位サービスを提供し、撮影をスムーズに進行。'
      }
    },
    process: {
      title: 'サービスフロー',
      step1: {
        title: 'ニーズ相談',
        description: '撮影ニーズ、予算、スケジュールを把握。'
      },
      step2: {
        title: 'プラン策定',
        description: '機材、チーム、ロケーション提案を含む完全な撮影プランを提供。'
      },
      step3: {
        title: '実行準備',
        description: '全リソースを調整し、行政手続きを処理、万全の準備を確保。'
      },
      step4: {
        title: '撮影サポート',
        description: '現場全体をサポートし、撮影をスムーズに完了。'
      }
    },
    form: {
      title: '今すぐ相談予約',
      description: '以下のフォームにご記入ください。できるだけ早くご連絡いたします',
      location: {
        label: '撮影場所',
        placeholder: '撮影場所を選択してください',
        taiwan: '台湾',
        japan: '日本',
        other: 'その他'
      },
      city: {
        label: '都市',
        placeholder: '都市名を入力してください'
      },
      dateRange: {
        start: '予定開始日',
        end: '予定終了日'
      },
      needTypes: {
        label: 'ニーズ項目',
        equipment: '機材レンタル',
        photographer: 'カメラマン',
        lighting: '照明技師',
        sound: '録音技師',
        dit: 'DIT',
        other: 'その他'
      },
      budget: {
        label: '予算範囲',
        placeholder: '予算範囲を選択してください',
        range1: 'NT$ 50,000 以下',
        range2: 'NT$ 50,000 - 100,000',
        range3: 'NT$ 100,000 - 300,000',
        range4: 'NT$ 300,000 - 500,000',
        range5: 'NT$ 500,000 以上',
        negotiable: '要相談'
      },
      company: {
        label: '会社名',
        placeholder: '会社名を入力してください（任意）'
      },
      name: {
        label: '担当者名',
        placeholder: 'お名前を入力してください'
      },
      email: {
        label: 'メールアドレス',
        placeholder: 'メールアドレスを入力してください'
      },
      phone: {
        label: '連絡先電話番号',
        placeholder: '電話番号を入力してください'
      },
      projectDescription: {
        label: 'プロジェクト説明',
        placeholder: '撮影プロジェクトの内容、要件、特別な要求を簡潔に説明してください...'
      },
      attachments: {
        label: '添付ファイル',
        description: '脚本、絵コンテ、参考資料などをアップロード可能（任意）'
      },
      submit: '相談を送信',
      submitting: '送信中...',
      success: 'お問い合わせありがとうございます！できるだけ早くご連絡いたします。',
      error: '送信に失敗しました。後でもう一度お試しください。'
    }
  },
  postProduction: {
    hero: {
      title: '日本編集・カラグレサービス',
      description: '日本のトップポストプロダクションチームと協力し、プロの編集、カラーグレーディング、エフェクト、サウンドポストプロダクションサービスを提供。ハイエンド広告、ブランド映像、映画など、最高品質が求められるプロジェクトに最適。'
    },
    viewWorks: '参考作品を見る',
    features: {
      title: 'サービスの特徴',
      quality: {
        title: '最高品質',
        description: '日本広告レベルのポストプロダクション基準、細部を正確に把握し、最高のビジュアル効果を実現。'
      },
      experience: {
        title: '豊富な経験',
        description: 'チームは広告、映画、MV制作の豊富な経験を有し、様々なスタイルと要件に精通。'
      },
      equipment: {
        title: 'プロ機器',
        description: 'DaVinci Resolve、Avid、Pro Tools など業界標準のソフトウェアとハードウェアを使用。'
      },
      communication: {
        title: 'バイリンガルコミュニケーション',
        description: '中日バイリンガルコミュニケーションサービスを提供し、要件を正確に伝達し、円滑な協力を実現。'
      }
    },
    services: {
      title: 'サービス項目',
      editing: {
        title: 'プロ編集',
        items: [
          '広告編集',
          'ブランド映像',
          'ドキュメンタリー編集',
          'ミュージックビデオ',
          '企業プロモーション'
        ]
      },
      grading: {
        title: 'プロカラグレ',
        items: [
          'DaVinci Resolve カラグレ',
          '映画級カラー管理',
          'スタイル化カラー',
          'HDR カラグレ',
          'LUT カスタマイズ'
        ]
      },
      vfx: {
        title: 'ビジュアルエフェクト',
        items: [
          '合成エフェクト',
          'モーショングラフィックス',
          'クロマキー合成',
          'シーン拡張',
          'エフェクト修復'
        ]
      },
      sound: {
        title: 'サウンドポストプロダクション',
        items: [
          'サウンドデザイン',
          'ナレーション録音',
          '音楽ミックス',
          '環境音処理',
          'ドルビーアトモス'
        ]
      }
    },
    process: {
      title: '制作フロー',
      step1: {
        title: 'ニーズ相談',
        description: 'プロジェクト要件、スタイル方向、予算、スケジュールを把握し、専門的な提案と見積もりを提供。'
      },
      step2: {
        title: '素材納品',
        description: 'クラウド経由で原素材を転送し、ファイル形式、カラースペース等技術要件を確認。'
      },
      step3: {
        title: '制作・試写',
        description: '編集、カラグレ、エフェクト制作を行い、オンライン試写システムでリアルタイムにコミュニケーションと修正。'
      },
      step4: {
        title: '完成納品',
        description: '最終版を完成させ、様々な形式のファイルを提供し、プロジェクトアーカイブサービスも実施。'
      }
    },
    form: {
      title: '今すぐ相談予約',
      description: '以下のフォームにご記入ください。できるだけ早くご連絡いたします',
      serviceType: {
        label: '必要なサービス',
        editing: '編集',
        grading: 'カラグレ',
        vfx: 'ビジュアルエフェクト',
        sound: 'サウンドポストプロダクション',
        package: '統合サービス'
      },
      projectType: {
        label: 'プロジェクトタイプ',
        placeholder: 'プロジェクトタイプを選択してください',
        commercial: '広告',
        brand: 'ブランド映像',
        mv: 'ミュージックビデオ',
        documentary: 'ドキュメンタリー',
        film: '映画/ショートフィルム',
        other: 'その他'
      },
      duration: {
        label: '動画長さ（秒）',
        placeholder: '例:30'
      },
      deadline: {
        label: '希望完成日'
      },
      budget: {
        label: '予算範囲',
        placeholder: '予算範囲を選択してください',
        range1: 'NT$ 30,000 以下',
        range2: 'NT$ 30,000 - 80,000',
        range3: 'NT$ 80,000 - 150,000',
        range4: 'NT$ 150,000 - 300,000',
        range5: 'NT$ 300,000 以上',
        negotiable: '要相談'
      },
      company: {
        label: '会社名',
        placeholder: '会社名を入力してください（任意）'
      },
      name: {
        label: '担当者名',
        placeholder: 'お名前を入力してください'
      },
      email: {
        label: 'メールアドレス',
        placeholder: 'メールアドレスを入力してください'
      },
      phone: {
        label: '電話番号',
        placeholder: '電話番号を入力してください'
      },
      reference: {
        label: '参考動画リンク',
        placeholder: 'YouTube、Vimeo などの動画リンク（任意）'
      },
      projectDescription: {
        label: 'プロジェクト説明',
        placeholder: 'プロジェクト内容、スタイル要件、特別な要求を簡潔に説明してください...'
      },
      submit: '相談を送信',
      submitting: '送信中...',
      success: 'お問い合わせありがとうございます！できるだけ早くご連絡いたします。',
      error: '送信に失敗しました。後でもう一度お試しください。'
    }
  },
  urent: {
    hero: {
      title: 'Urent 寄託レンタル',
      description: '遊休撮影機材をLensBankに預け、保管・メンテナンス・レンタル管理を任せ、分配収益を受け取るだけ。'
    },
    features: {
      title: 'サービス特徴',
      income: {
        title: '受動的収入',
        description: '機材が遊休時でも収益を創出し、投資が継続的にリターンを生み出す。'
      },
      management: {
        title: '専門管理',
        description: '恒温恒湿の保管環境、定期的なメンテナンスで機材を最適状態に保つ。'
      },
      insurance: {
        title: '保険保障',
        description: '完全な機材保険、レンタル期間中の損傷はプラットフォームが負担。'
      },
      transparent: {
        title: '透明な分配',
        description: '明確な分配メカニズム、毎月定期的に精算・振込。'
      }
    },
    howItWorks: {
      title: '寄託プロセス',
      step1: {
        title: '申請提出',
        description: '機材情報と写真を記入し、購入証明と付属品リストを提供。'
      },
      step2: {
        title: '評価審査',
        description: '機材の状態、市場需要を評価。'
      },
      step3: {
        title: '契約締結',
        description: '分配比率、保管条項、保険内容を確認。'
      },
      step4: {
        title: '寄託開始',
        description: '機材を掲載し、レンタル開始。'
      }
    },
    revenue: {
      title: '収益分配',
      description: '透明公開の分配メカニズムで、機材の最大価値を創出',
      owner: '機材所有者',
      platform: 'プラットフォーム管理費',
      note: '* 実際の分配比率は機材タイプと市場需要に応じて調整'
    },
    requirements: {
      title: '寄託条件',
      item1: '機材は正常に使用可能な状態で、重大な欠陥や故障がないこと',
      item2: '完全な付属品（バッテリー、充電器、原装パッケージ等）を提供',
      item3: '購入証明または領収書を提供（機材の合法的な出所を保証）',
      item4: '機材市場価値は NT$ 30,000 以上であること',
      item5: '寄託契約と保険条項に同意すること'
    },
    form: {
      title: '今すぐ申請',
      description: '以下のフォームにご記入ください。できるだけ早くご連絡いたします',
      equipmentName: {
        label: '機材名',
        placeholder: '例：Canon EOS R5、Sony FX3'
      },
      category: {
        label: '機材カテゴリ',
        placeholder: 'カテゴリを選択してください',
        camera: 'カメラ',
        lens: 'レンズ',
        lighting: '照明',
        sound: '録音',
        monitor: 'モニター',
        stabilizer: 'スタビライザー',
        other: 'その他'
      },
      brand: {
        label: 'ブランド',
        placeholder: '例：Canon、Sony、RED'
      },
      purchaseDate: {
        label: '購入日'
      },
      condition: {
        label: '機材状態',
        new: '新品未使用',
        excellent: '極上（90％以上新品同様）',
        good: '良好（70-80％新品同様）',
        fair: '可（50-60％新品同様）'
      },
      accessories: {
        label: '付属品リスト',
        placeholder: 'すべての付属品を詳述、例：純正バッテリーx2、充電器、原装パッケージ、説明書...'
      },
      rentalPeriod: {
        label: '希望レンタル期間',
        placeholder: 'レンタル期間を選択してください',
        threeMonths: '3ヶ月',
        sixMonths: '6ヶ月',
        oneYear: '1年',
        twoYears: '2年',
        threeYears: '3年'
      },
      photos: {
        label: '機材写真',
        description: '正面、側面、背面、付属品などの高解像写真（最低3枚）'
      },
      name: {
        label: '担当者名',
        placeholder: 'お名前を入力してください'
      },
      email: {
        label: 'メールアドレス',
        placeholder: 'メールアドレスを入力してください'
      },
      phone: {
        label: '電話番号',
        placeholder: '電話番号を入力してください'
      },
      notes: {
        label: '備考',
        placeholder: 'その他の情報を記入してください'
      },
      agreement: {
        label: '規約に同意します',
        terms: '寄租サービス規約'
      },
      disclaimer: '最終審議権を保留します。',
      submit: '申請を送信',
      submitting: '送信中...',
      success: 'ご応募ありがとうございます！できるだけ早くご連絡いたします。',
      error: '送信に失敗しました。後でもう一度お試しください。'
    },
    title: 'Urent 寄託レンタル',
    subtitle: '遊休機材に価値を創出',
    desc: '遊休撮影機材をLensBankに預け、保管・メンテナンス・レンタル管理を任せ、分配収益を受け取るだけ。',
    highlights: [
      '専門保管：恒温恒湿の保管環境',
      '定期メンテナンス：専門チームによる定期点検',
      '保険保障：完全な機材保険',
      '透明分配：明確な収益分配メカニズム',
      '柔軟な取戻し：いつでも自分の機材を取戻せる'
    ],
    process: {
      title: '寄託プロセス',
      steps: [
        {
          title: '申請提出',
          desc: '機材情報と写真を記入'
        },
        {
          title: '評価審査',
          desc: '機材状態と市場需要評価'
        },
        {
          title: '契約締結',
          desc: '分配比率と保管条項確認'
        },
        {
          title: '開始寄託',
          desc: '寄託開始の手続きを行う'
        }
      ]
    }
  },
  cta: {
    title: 'プロジェクトを始める準備はできましたか？',
    subtitle: '今すぐお問い合わせください。プロチームがあなたのクリエイティブを実現します',
    button: '今すぐ相談'
  }
};